const cities = [
  { name: "St. Joseph", zips: "64501, 64502, 64503, 64504, 64505, 64506, 64507, 64508" },
  { name: "Savannah", zips: "64485" },
  { name: "Kearney", zips: "64060" },
  { name: "Smithville", zips: "64089" },
  { name: "Platte City", zips: "64079" },
  { name: "Atchison, KS", zips: "66002" },
  { name: "Maryville", zips: "64468" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your home or office in St. Joseph or Buchanan County in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping from any UPS or FedEx location in St. Joseph to send documents directly — we handle every detail.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no appointment race against other travelers.",
  },
];

export default function StJosephLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving St. Joseph &amp; Northwest Missouri
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              St. Joseph is the commercial anchor of Northwest Missouri, a region whose international travel demands are shaped by two distinct forces: agriculture and education. Missouri's beef cattle industry — one of the largest in the country — is concentrated in a corridor stretching from St. Joseph north to Maryville and east toward Chillicothe. Cattle buyers, export brokers, and livestock industry professionals travel regularly to Canada, Mexico, Australia, and Brazil on trade schedules that can be as unpredictable as commodity markets. A last-minute trade delegation or export inspection can require a passport within days, not months.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Missouri Western State University adds the educational travel dimension. With an enrollment of nearly 5,000 students, MWSU sends dozens of students abroad each semester through exchange programs, study-abroad partnerships, and international research collaborations. Many first-time passport applicants are MWSU students who receive program acceptance notifications in late fall or early spring — when standard government processing timelines put their participation at risk. Faculty who travel for academic conferences or international research face similar constraints.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Beyond agriculture and education, St. Joseph's I-29 corridor position makes it a logistics and distribution hub. Major companies with operations here — including Amazon's regional distribution footprint — connect St. Joseph to global supply chains that occasionally require management-level international travel on short notice. Healthcare professionals at Mosaic Life Care travel for training, conferences, and collaborative patient care programs in Canada, Europe, and Latin America.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              The Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 is the nearest regional passport agency — approximately 500 miles northeast. Appointments are for documented life-or-death emergencies only. Fast Passport Center eliminates that variable: start online, ship your documents overnight from St. Joseph, and receive your passport within the timeframe you choose. No appointment race. No 8-hour drive. Just reliable, professional expedited processing from a registered U.S. Department of State courier.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — St. Joseph, MO</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Northwest Missouri &amp; Buchanan County</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Serving Buchanan County, Andrew County &amp; the I-29 corridor
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Serving St. Joseph, Savannah, Kearney, Smithville, and surrounding communities</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  Start your order online, then <strong className="text-white">ship with our prepaid label</strong> from the St. Joseph UPS or FedEx, or schedule a drop-off. Most clients ship overnight — no appointment in Chicago required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Northwest Missouri — start online, ship overnight, and we handle the rest. No need to race for a Chicago appointment.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Missouri Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Kansas City", href: "/cities/kansas-city" },
                    { name: "Springfield", href: "/cities/springfield-mo" },
                    { name: "Columbia", href: "/cities/columbia-mo" },
                    { name: "St. Louis", href: "/cities/st-louis" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why St. Joseph Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}